import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { FormValues } from '../../interfaces';

type Props = {
  formValues: FormValues;
  setFormValues: any;
  nextStep: () => void;
};

const validationSchema = yup.object({
  styles: yup.string().required('Required'),
});

function Styles({ formValues, setFormValues, nextStep }: Props) {
  const questionValues = {
    header: 'What are your favorite styles of tattoos?',
    progress: 3,
  };

  const formik = useFormik({
    initialValues: {
      styles: formValues.styles,
    },
    validationSchema,
    validateOnMount: true,
    onSubmit: values => {
      setFormValues({
        ...formValues,
        ...values,
      });
      sessionStorage.setItem('styles', values.styles!);
      nextStep();
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Typography variant="h2" className="form-header">
        {questionValues.header}
      </Typography>
      <TextField
        id="styles"
        name="styles"
        value={formik.values.styles}
        onChange={formik.handleChange}
        error={formik.touched.styles && Boolean(formik.errors.styles)}
        helperText={formik.touched.styles && formik.errors.styles}
        multiline
        placeholder="You can list of names of different tattoo styles you typically like, or just describe what they look like and what you prefer!"
        minRows={3}
        className="textarea"
      />
      <Button
        variant="contained"
        className={`next ${formik.isValid ? 'done' : ''}`}
        type="submit">
        Next
      </Button>
    </form>
  );
}

export default Styles;
